import { createSlice } from '@reduxjs/toolkit'

// Restore token from localStorage on init
const getTokenFromStorage = () => {
    return localStorage.getItem('expo-skripsi') || '';
};

export const authSlice = createSlice({
    name: 'auth',
    initialState: { 
        token       : getTokenFromStorage()
        ,user       : false
        ,notif      : 0
        ,fetching   : true
    }
    ,reducers : {
        setUser : (state, action) => {
            // console.log('Set User Reducer auth called', action);
            // SetUser receives token (string)
            const token = action.payload || '';
            if (token) {
                window.localStorage.setItem('expo-skripsi', token);
            } else {
                // If token is empty, remove from localStorage
                window.localStorage.removeItem('expo-skripsi');
                state.user = false;
            }
            
            state.token = token;
        }
        ,setTokenizeUser : (state, action) => {

            // console.log('Set Tokenized User Reducer auth called', action.payload);
            // SetTokenizeUser receives user object
            // User object hanya disimpan di state, tidak di localStorage
            state.user = action.payload || false;

        }
        ,setLookingUser : (state, action) => {
            // console.log('Set Loading User Reducer auth called', action.payload);

            state.fetching = action.payload;
        }
        ,setUserNotif : (state, action) => {
            // console.log('Set Current User Unglanced Count', action.payload);
            state.notif = action.payload;
        }
    }
});

export default authSlice.reducer;